import { Alert, AlertTitle, Stack, Typography } from "@mui/material";
import type { ObjectLockDetails } from "../../api/types/objectTypes";

interface Props {
  objectLocks: ObjectLockDetails[];
}

const ObjectEditingLockAlert = ({ objectLocks }: Props) => {
  return (
    <Alert severity="info">
      <AlertTitle>Editing is locked</AlertTitle>
      <Stack spacing={1}>
        {objectLocks
          .filter((l) => Boolean(l.lockReason))
          .map((lock, index) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Typography key={index}>{lock.lockReason}</Typography>
          ))}
      </Stack>
    </Alert>
  );
};

export default ObjectEditingLockAlert;
